import CityPageTemplate from "../city-template/CityPageTemplate";
import { denverConfig } from "./data";

export default function DenverPage() {
  return <CityPageTemplate config={denverConfig} />;
}